import {IStore} from "modules/types";

export const getContactUs = ({contact_us}: IStore) => contact_us;
export const isDataRequestedContactUs = ({contact_us}: IStore) => contact_us.is_data_requested;
export const isDataContactUsSended = ({contact_us}: IStore) => contact_us.is_success;
